import { createContext } from 'react'

const controlHubContext = createContext()

export default controlHubContext
